"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var vue_property_decorator_1 = require("vue-property-decorator");
var UserInterestEmpty_vue_1 = __importDefault(require("../UserInterestEmpty.vue"));
var ScrollElement_vue_1 = __importDefault(require("../../scroll-element/ScrollElement.vue"));
var CollectionPreview_vue_1 = __importDefault(require("../../collection-preview/CollectionPreview.vue"));
var collection_preview_1 = require("../../collection-preview/collection-preview");
var collection_index_service_1 = require("../../collection-index/collection-index.service");
var pagination_1 = require("../../../../js/pagination");
var collection_preview_2 = require("../../collection-preview/collection-preview");
var UserInterestCollections = /** @class */ (function (_super) {
    __extends(UserInterestCollections, _super);
    function UserInterestCollections() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.perPage = 6;
        _this.items = [];
        _this.pagination = null;
        _this.fetchingPage = false;
        _this.itemsContainerClasses = [
            'js-scroll-element', 'scroll-container-x', 'scroll-behavior-smooth',
            'user-interest-previews-container', 'd-flex', 'overflow-auto', 'py-3', 'pr-lg-5'
        ];
        _this.itemWrapperClasses = ['scroll-snap-center', 'mb-3', 'col-12', 'col-md-8'];
        return _this;
    }
    UserInterestCollections.prototype.created = function () {
        this.apiService = new collection_index_service_1.ApiCollectionIndexV1({
            http: this.$http,
            fetchPageUrl: '/local/api/v2/collections/user-interest',
        });
        this.fetchPage(1);
    };
    UserInterestCollections.prototype.fetchPage = function (page, search) {
        var _this = this;
        this.fetchingPage = true;
        this.apiService.fetchPage(page, this.perPage, search)
            .then(this.setPaginatedValues)
            .finally(function () {
            _this.fetchingPage = false;
        });
    };
    UserInterestCollections.prototype.setPaginatedValues = function (data) {
        if (!data.page) {
            return;
        }
        this.setPagination(data.page);
        this.items = data.page.data
            .filter(function (rawPreview) {
            return typeof rawPreview.type === 'string';
        })
            .map(function (rawPreview) {
            var item = {
                type: rawPreview.type,
                preview: (0, collection_preview_2.createCollectionPreview)(rawPreview)
            };
            item.preview.processing = false;
            return item;
        });
    };
    UserInterestCollections.prototype.setPagination = function (pagination) {
        this.pagination = new pagination_1.PageBaseV1({
            total: pagination.total,
            per_page: pagination.per_page,
            current_page: pagination.current_page,
            last_page: pagination.last_page,
            next_page_url: pagination.next_page_url,
            prev_page_url: pagination.prev_page_url,
            from: pagination.from,
            to: pagination.to,
        });
    };
    UserInterestCollections.prototype.updateItemPreview = function (type, preview) {
        var index = this.items
            .findIndex(function (item) {
            return item.type === type && item.preview.id === preview.id;
        });
        if (index === -1) {
            return;
        }
        this.items.splice(index, 1, {
            type: type,
            preview: preview,
        });
    };
    UserInterestCollections.prototype.toggleFavoriteCollection = function (preview) {
        var _this = this;
        if (preview.processing) {
            return;
        }
        preview.processing = true;
        (0, collection_preview_1.toggleFavorite)(preview, this.$http)
            .then(function (data) {
            preview.processing = false;
            preview.favorited = data.favorited;
            _this.updateItemPreview('collection', preview);
        });
    };
    UserInterestCollections.prototype.buildUrl = function (relativePath) {
        return this.$http.defaults.baseURL + relativePath;
    };
    UserInterestCollections = __decorate([
        (0, vue_property_decorator_1.Component)({
            components: {
                CollectionPreview: CollectionPreview_vue_1.default,
                UserInterestEmpty: UserInterestEmpty_vue_1.default,
                ScrollElement: ScrollElement_vue_1.default,
            }
        })
    ], UserInterestCollections);
    return UserInterestCollections;
}(vue_1.default));
exports.default = UserInterestCollections;
